import { getMessages } from '../../../../../../../../store/constants';

export const MY_WORK_SETTINGS_FILTER_BAR_TITLE = getMessages().getText('assigned_to_me.settings.filter_bar.title');
export const MY_WORK_SETTINGS_FILTER_BAR_COLLAPSED_LABEL = getMessages().getText('assigned_to_me.settings.filter_bar.collapsed');
export const MY_WORK_SETTINGS_FILTER_BAR_EXPANDED_LABEL = getMessages().getText('assigned_to_me.settings.filter_bar.expanded');
